// components/RegisterModal.jsx
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  DialogActions,
  Grid,
  Alert,
  Snackbar,
} from "@mui/material";

import { useAuth } from "../context/AuthContext";
import { register as register } from "../services/index";
const RegisterModal = ({ open, onClose }) => {
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    dob: "",
    password: "",
    college: "",
    area_of_study: "",
    expertise: "",
    language_spoken1: "",
    language_spoken2: "",
    about: "",
    role_id: ""
  });
  const { login } = useAuth();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  const handleRegister = async () => {
    try {
      const response = await register({
        email: form.email,
        password: form.password,
        first_name: form.first_name,
        last_name: form.last_name,
        dob: form.dob,
        mobile: form.mobile,
        area_of_study: form.area_of_study,
        college: form.college,
        expertise: form.expertise,
        language_spoken1: form.language_spoken1,
        language_spoken2: form.language_spoken2,
        about: form.about,
        country_studied_in: form.country_studied_in,
        role_id:form.role_id
      });

      if (response.status === 200) {
        const logindata = JSON.stringify(response.data);
        const { token, user_type, data } = response.data;
        localStorage.setItem("token", token);


        login(user_type, logindata); // set login in context
        onClose(); // close modal

        setSnackbar({
          open: true,
          message: "Registration successful!",
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Login error:", error?.response?.data?.message);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || "Login failed. Please try again.",
        severity: "error",
      });
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Register</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={6}>
              <TextField
                name="first_name"
                label="First Name"
                fullWidth
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="last_name"
                label="Last Name"
                fullWidth
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="email"
                label="Email"
                fullWidth
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="mobile"
                label="Mobile Number"
                fullWidth
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="dob"
                label="Date of Birth"
                type="date"
                fullWidth
                variant="standard"
                InputLabelProps={{ shrink: true }}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="password"
                label="Password"
                type="password"
                fullWidth
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleRegister}>Register</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default RegisterModal;
